import type { OtherTextFieldProps } from '@/pages/onboarding/onboarding.types';
import { Input, Label, Stack } from '@careflux/primitives';
import { Controller } from 'react-hook-form';

/** Free-text follow-up shown when "Annað" is chosen. */
export const OtherTextField = ({ name, id, label, placeholder, control }: OtherTextFieldProps) => (
  <Controller
    name={name}
    control={control}
    render={({ field }) => (
      <Stack gap="sm">
        <Label htmlFor={id}>{label}</Label>
        <Input
          id={id}
          value={field.value}
          onChange={field.onChange}
          onBlur={field.onBlur}
          placeholder={placeholder}
          maxLength={200}
        />
      </Stack>
    )}
  />
);
